import type { ContextGuards, Guard } from './types.js';

export function some(...guards: Guard[]) {
  return (ctx: ContextGuards) => guards.some((guard) => guard(ctx));
}
